import _ from 'underscore';
import { DeterministicView, helpers } from '@bingads-webui/deterministic-view';
import { RANGES } from '@bingads-webui/date-ranges';
import template from './date-range-panel-base-template.pug';
import { CustomDateRangeSelectionPanel } from '../custom-date-range/custom-date-range-selection-view';
import { CustomTimeRangeSelectionPanel } from '../custom-time-range/custom-time-range-selection-view';

const { updateView, ensureChildView } = helpers;
/**
 * The base class for the date range panels
 * @extends {View}
 */
export class DateRangePanelBase extends DeterministicView {
  /**
   * Initialize the DateRangePanelBase
   * @param {Object} options - View construction options
   * @returns {void}
   */
  initialize(options) {
    this.options = options;
    this.RANGES = RANGES;
  }

  get events() {
    return {
      'click .dropdown-item': (e) => {
        const key = this.$(e.target).closest('.dropdown-item').first().attr('data-key');
        if (!key) {
          throw new Error('No key found');
        }
        const dateRanges = this.model.get('dateRanges');
        if (dateRanges[key].isCustom) {
          e.stopPropagation();
        }
        if (key === this.model.get('selectedKey')) return;

        updateView(this, { selection: dateRanges[key], selectedKey: key });
        this.showDatePickersIfCustomSelected();

        this.trigger('range-checked', dateRanges[key]);
      },
    };
  }

  /**
 * Shows the date pickers if a custom range has been selected
 * @returns {undefined}
 */
  showDatePickersIfCustomSelected() {
    const { selectedKey, dateRanges } = this.model.attributes;
    const selectedRange = dateRanges[selectedKey];
    if (selectedRange.isCustom) {
      if (selectedKey === RANGES.CUSTOM) {
        ensureChildView(
          this, 'customDateRangeSelectionPanel', CustomDateRangeSelectionPanel,
          {
            startDate: selectedRange.start,
            endDate: selectedRange.end,
            i18n: this.options.i18n,
            minDate: this.options.minDate,
            maxDate: this.options.maxDate,
          }
        );
      } else if (selectedKey === RANGES.CUSTOM_TIME) {
        let childView = this.getChild('customTimeRangeSelectionPanel');
        if (!childView) {
          childView = new CustomTimeRangeSelectionPanel({
            i18n: this.options.i18n,
            minDate: this.options.minDate,
            maxDate: this.options.maxDate,
          }).setState({
            date: selectedRange.start,
            startTime: this.options.defaultTimeRange.start,
            endTime: this.options.defaultTimeRange.end,
          });
          this.setChild('customTimeRangeSelectionPanel', childView);
        }
      }
    }
  }

  get template() {
    return template;
  }

  /**
 * Gets the checked date range
 * @returns {Object} - The checked date range
 */
  getCheckedRange() {
    const { dateRanges, selectedKey } = this.model.attributes;

    if (dateRanges[selectedKey].isCustom) {
      if (selectedKey === RANGES.CUSTOM) {
        _.extend(dateRanges[selectedKey], this.getChild('customDateRangeSelectionPanel').getSelection());
      } else if (selectedKey === RANGES.CUSTOM_TIME) {
        _.extend(dateRanges[selectedKey], this.getChild('customTimeRangeSelectionPanel').getSelection());
      }
    }
    return dateRanges[selectedKey];
  }
}
